module.exports = __webpack_public_path__ + "img/project-1.d7e3d46a.jpg";